import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="student-certificate-applications"
export default class extends Controller {
	static targets = ["quantityE", "quantityJ", "englishName"]

	connect() {
		this.changeEnglishApp()
	}

	changeApp(event) {
		if (event.target.dataset.studentCertificateApplicationsTarget == "quantityE") {
			this.changeEnglishApp()
		}
	}

	changeEnglishApp() {
		let quantity = 0
		this.quantityETargets.forEach((target) => {
			quantity += Number(target.value)
		})
		if (quantity > 0) {
			this.englishNameTarget.disabled = false
		} else {
			this.englishNameTarget.disabled = true
		}
	}
}
